

export class VehicleDetailsSelectOutput implements IVehicleDetailsSelectOutput {
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The company name with 50 character limit */
    company_name!: string;
    /** The branch name with 50 character limit */
    branch!: string;
    /** The vehicle type name with 50 character limit */
    vehicle_type_name!: string;
    /** The vehicle type name with 50 character limit */
    vehicle_company_name!: string;
    /** The vehicle model name with 50 character limit */
    vehicle_model_name!: string;
    /** The vehicle number with 50 character limit */
    vehicle_number!: string;
    /** The vehicle icon */
    vehicle_icon!: string;
    /** The vehicle category must be Movable or Immovable */
    vehicle_category!: string;
    /** The vehicle special feature with 500 character limit */
    special_feature!: string;
    /** The auto-generated id of the alert group master */
    alert_group_id!: number;
    /** The auto-generated creating time of tbl_vehicle_details item add */
    creating_date!: any;
    /** The auto-generated creating or updating time of tbl_vehicle_details item add or update */
    updating_date!: any;
    /** Manage status of vehicle details. 0 For De-active, 1 For Active */
    status!: number;
    /** The odometer of vehicle with 10 character limit */
    odometer!: number;

    constructor(data?: IVehicleDetailsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.company_name = _data["company_name"];
            this.branch = _data["branch"];
            this.vehicle_type_name = _data["vehicle_type_name"];
            this.vehicle_company_name = _data["vehicle_company_name"];
            this.vehicle_model_name = _data["vehicle_model_name"];
            this.vehicle_number = _data["vehicle_number"];
            this.vehicle_icon = _data["vehicle_icon"];
            this.vehicle_category = _data["vehicle_category"];
            this.special_feature = _data["special_feature"];
            this.alert_group_id = _data["alert_group_id"];
            this.creating_date = _data["creating_date"];
            this.updating_date = _data["updating_date"];
            this.status = _data["status"];
            this.odometer = _data["odometer"];
        }
    }

    static fromJS(data: any): VehicleDetailsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["company_name"] = this.company_name;
        data["branch"] = this.branch;
        data["vehicle_type_name"] = this.vehicle_type_name;
        data["vehicle_company_name"] = this.vehicle_company_name;
        data["vehicle_model_name"] = this.vehicle_model_name;
        data["vehicle_number"] = this.vehicle_number;
        data["vehicle_icon"] = this.vehicle_icon;
        data["vehicle_category"] = this.vehicle_category;
        data["special_feature"] = this.special_feature;
        data["alert_group_id"] = this.alert_group_id;
        data["creating_date"] = this.creating_date;
        data["updating_date"] = this.updating_date;
        data["status"] = this.status;
        data["odometer"] = this.odometer;
        return data; 
    }
}

export interface IVehicleDetailsSelectOutput {
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The company name with 50 character limit */
    company_name: string;
    /** The branch name with 50 character limit */
    branch: string;
    /** The vehicle type name with 50 character limit */
    vehicle_type_name: string;
    /** The vehicle type name with 50 character limit */
    vehicle_company_name: string;
    /** The vehicle model name with 50 character limit */
    vehicle_model_name: string;
    /** The vehicle number with 50 character limit */
    vehicle_number: string;
    /** The vehicle icon */
    vehicle_icon: string;
    /** The vehicle category must be Movable or Immovable */
    vehicle_category: string;
    /** The vehicle special feature with 500 character limit */
    special_feature: string;
    /** The auto-generated id of the alert group master */
    alert_group_id: number;
    /** The auto-generated creating time of tbl_vehicle_details item add */
    creating_date: any;
    /** The auto-generated creating or updating time of tbl_vehicle_details item add or update */
    updating_date: any;
    /** Manage status of vehicle details. 0 For De-active, 1 For Active */
    status: number;
    /** The odometer of vehicle with 10 character limit */
    odometer: number;
}

